<template>
    <div class="kinds" :class="{ isPremium }" v-if="profile">
        <div class="badge badge-kind" :key="item.key" v-for="item in items">
            <span v-if="!hideKey" class="key">{{ humanizeKey(item) }}</span>
            <span class="value">{{ humanizeValue(item) | translate }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Kinds',
    props: ['profile', 'hideKey', 'isPremium'],
    computed: {
        items() {
            const items = [
                'kind',
                'mbti',
                'shape',
                'smoking',
                'religion_name',
                'car',
                'pet',
                'car_type',
                'exercise',
                'house_style',
                'house_payment',
            ]
            const result = []
            items.forEach(key => {
                let value =
                    this.profile[key] && typeof this.profile[key] === 'object'
                        ? this.profile[key].name
                        : this.profile[key]

                if (key === 'smoking' && this.profile[key] === false) {
                    value = '비흡연'
                }

                if (value) {
                    result.push({
                        key: key,
                        value: value,
                    })
                }
            })

            return result
        },
    },
    methods: {
        humanizeKey(item) {
            return this.$translate(item.key.toUpperCase())
        },
        humanizeValue(item) {
            if (item.key === 'car') {
                return item.value ? '보유' : '미보유'
            }
            if (item.key !== 'smoking') {
                return item.value || '-'
            }

            return item.value === '비흡연'
                ? this.hideKey
                    ? 'NON_SMOKING'
                    : '비흡연'
                : this.hideKey
                ? 'SMOKING'
                : '흡연'
        },
    },
}
</script>

<style lang="scss" scoped>
.badge-kind {
    .key {
        font-family: NotoSans-Regular !important;
        color: $grey-05 !important;
    }
}
</style>
